import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import config from '../config/environment';

// Firebase configuration from environment
const firebaseConfig = {
    apiKey: config.FIREBASE.API_KEY,
    authDomain: config.FIREBASE.AUTH_DOMAIN,
    projectId: config.FIREBASE.PROJECT_ID,
    storageBucket: config.FIREBASE.STORAGE_BUCKET,
    messagingSenderId: config.FIREBASE.MESSAGING_SENDER_ID,
    appId: config.FIREBASE.APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

let chatFirestore = null;

/** Firestore client for the chat Native database (not the project default DB). */
export function getChatFirestore() {
    const databaseId = (config.CHAT_FIRESTORE_DATABASE_ID || '').trim();
    if (!databaseId) {
        throw new Error('REACT_APP_CHAT_FIRESTORE_DATABASE_ID is not configured');
    }
    if (!chatFirestore) {
        chatFirestore = getFirestore(app, databaseId);
    }
    return chatFirestore;
}

export function isChatFirestoreListenerAvailable() {
    return Boolean((config.CHAT_FIRESTORE_DATABASE_ID || '').trim());
}

export default app;
